import { styled } from '@mui/material'

const ScrollSubHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  maxWidth: 1320,
  margin: '0 auto',
  gap: theme.spacing(5),
  '& svg': {
    color: theme.palette.primary.main
  },
[theme.breakpoints.down('sm')]: {
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  width:'320px',
  gap: theme.spacing(2), 
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
}
}))

export default ScrollSubHeader
